// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    production: false,
    rootUrl: 'http://localhost:5001',
    clientId: 'E489571B-6942-4316-975B-D5E40A4E18A',
    pageSize: 10,
    yearRangeForDatePicker: '1950' + ':' + new Date().getFullYear(),
    formatType: 'US',
    datetimeformat: 'MM/dd/yyyy HH: mm: ss',
    dateformat: 'MM/dd/yyyy',
    //SetTimeOut Delay Time in milli seconds
    setDelayTimeOut: 2000,
    version: "4.1.20",
    copyrightDate: "2017-2025 eMedApps Inc",
}
